export default __webpack_public_path__ + "92840129c57d8724400f4ba154cdf8e5.svg";